import { graphql } from 'react-relay';

const productDetailsQuery = graphql`
  query ProductDetailsQuery($input: VariantQueryInput) {
    variant(input: $input) {
      result {
        departments {
          ref_id
          name
        }
        categories {
          ref_id
          name
        }
        current_user_review {
          ref_id
          review
          rating
        }
        root_variant_id
        product_type
        required_services_amount
        eligible_stock
        variant_services {
          ref_id
          name
        }
        root_variant {
          wish_listed
        }
        summary
        ...VariantCommonFieldsFragment @relay(mask: false)
        description
        gift_image{
          url_large
          url_original
        }
        gift_text
        gift_included
        
        brand {
          name
        }
        made_in {
          name
        }
        avg_rating
        rating_count
        wish_listed
        images_attachments {
          alt
          url_large
          url_original
          url_product
        }
        price
        original_price
        option_values {
          ...OptionValuesFragment @relay(mask: false)
        }
        vendor_available_variants {
          ...VariantCommonFieldsFragment @relay(mask: false)
          option_values {
            ...OptionValuesFragment @relay(mask: false)
          }
          vendor{
            ...VendorFragment @relay(mask: false)
          }
          min_variant{
            vendor{
              ...VendorFragment @relay(mask: false)
            }
          }
        }
        product_vendor_variants{
          ...VariantCommonFieldsFragment @relay(mask: false)
          min_variant{
            vendor{
              ...VendorFragment @relay(mask: false)
            }
          }
        }
        discount
        total_on_hand
        in_stock
        vendor {
         ...VendorFragment @relay(mask: false)
         vendor_track {
          name
          track_type
         }
         departments {
           ref_id
           name
           enabled
         }
        }
        product {
          id
          ref_id
          name
          tax_status
          dimensions
          weight
          meta_keywords
          meta_description
          meta_title
          option_types {
            id
            ref_id
            presentation
            option_values {
              ...OptionValuesFragment @relay(mask: false)
            }
          }
          size_chart {
            id
            ref_id
            metric
          }
          product_properties {
            id
            name
            presentation
            ref_id
            value
          }
          root_variants {
            ...VariantCommonFieldsFragment @relay(mask: false)
            option_values {
              ...OptionValuesFragment @relay(mask: false)
            }
          }
          related_products {
            ...Product_productInfo
          }
        }
        available_in_offers{
          name
          ref_id
          id
          slug
          vendor_variants_count
          min_variant{
            vendor{
              ...VendorFragment @relay(mask: false)
            }
          }
        }
        offered_variants{
          quantity
          variant{
            ...VariantCommonFieldsFragment @relay(mask: false)
            min_variant{
              vendor{
                ...VendorFragment @relay(mask: false)
              }
            }
            option_values {
             ...OptionValuesFragment @relay(mask: false)
            }
          }
        }
        has_offer
        has_discount
        hot_deal
        offer_saved_amount
        offer_saved_percent
      }
      errors {
        field
        messages
        code
      }
    }
  }
`;

export default productDetailsQuery;
